<template>
    <div>
        <button
            class="flex items-center justify-between w-full text-left h6 py-3 border-b border-secondary-300 focus:outline-none"
            type="button"
            @click.prevent="toggle"
        >
            <span>{{ title }}</span>
            <span>
                <svg
                    aria-hidden="true"
                    focusable="false"
                    class="block w-4 h-4 transition-transform duration-300 ease-in-out"
                    :class="{ 'rotate-180': expanded }"
                    role="img"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 448 512"
                >
                    <path fill="currentColor" d="M441.9 167.3l-19.8-19.8c-4.7-4.7-12.3-4.7-17 0L224 328.2 42.9 147.5c-4.7-4.7-12.3-4.7-17 0L6.1 167.3c-4.7 4.7-4.7 12.3 0 17l209.4 209.4c4.7 4.7 12.3 4.7 17 0l209.4-209.4c4.7-4.7 4.7-12.3 0-17z" />
                </svg>
            </span>
        </button>

        <div v-show="expanded" :aria-expanded="expanded">
            <div class="py-4">
                <slot></slot>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        title: {
            type: String,
            required: true,
        },
    },

    data() {
        return {
            expanded: false,
        };
    },

    methods: {
        toggle() {
            this.expanded = !this.expanded;
        },
    },
};
</script>
